import React from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from '@mui/material/Tooltip';
import { useTranslate } from '@im/react-localization';
import { useSiteConfig } from 'mf_core/config';
import Typography from '@mui/material/Typography';

type Props = {
  centralFlag: boolean;
  quantity: number;
  stockStatus: string;
};

export default function WarehouseETAQuantityAvailablity(props: Props) {
  const translate = useTranslate();
  const { siteCode } = useSiteConfig();
  return (
    <>
      {siteCode?.toUpperCase() === 'GB' &&
      props.centralFlag &&
      props.stockStatus === 'In Stock' ? (
        <Typography component="span">
          {props.quantity}{' '}
          <Tooltip
            arrow
            placement={'bottom-start'}
            title={translate('Warehouse.ETAQuantityUKInStockTooltipsText')}
          >
            <InfoOutlinedIcon
              sx={{
                fontSize: '1.5rem',
                marginBottom: '-6px',
                marginLeft: '4px',
              }}
            ></InfoOutlinedIcon>
          </Tooltip>
        </Typography>
      ) : (
        props.quantity
      )}
    </>
  );
}
